import { useSelector, useDispatch } from 'react-redux';
import { useState, useCallback } from 'react';
import { RootState, AppDispatch } from '@reducers/index';
import { changeSubAccountTeamName, setLogOut } from '@reducers/authSlice';
import { useNavigate } from 'react-router-dom';
import { accountMenu, accountMenuArray, subAccountType } from '@models/auth/authModel';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';

const MyAccountPopup = ({ popupCloseFn }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { userInfo } = useSelector(({ auth }: RootState) => auth);
  const { selectedCountry, selectedLanguage } = useSelector(({ LAYOUT }: RootState) => LAYOUT);
  const [selectedSubAccount, setSelectedSubAccount] = useState(null);
  const [teamNameText, setTeamNameText] = useState('');

  const onChangeTeamNameText = useCallback((event) => {
    const { value } = event.target;
    setTeamNameText(value);
  }, []);

  const onClickSubAccountPopup = useCallback((subAcountObj) => {
    if (subAcountObj) {
      const { teamName, email } = subAcountObj;
      setSelectedSubAccount(subAcountObj);
      setTeamNameText(teamName);
    } else {
      setSelectedSubAccount(null);
      setTeamNameText('');
    }
  }, []);

  const onClickRequestTeamChange = useCallback(async () => {
    if (selectedSubAccount) {
      const { userId } = userInfo;
      const { teamName, teamId, email } = selectedSubAccount;

      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', {
        params: { userId, subEmail: email, changeTeamName: teamNameText },
      });

      if (status === 200) {
        alert('Your team name Changed, Successfully!');
        dispatch(changeSubAccountTeamName({ teamName: teamNameText, email: email, teamId: teamId }));
        setSelectedSubAccount(null);
        setTeamNameText('');
      }
    }
  }, [selectedSubAccount, userInfo, teamNameText, dispatch]);

  const onClickMenu = useCallback(
    (event) => {
      switch (event.name) {
        case accountMenu.account:
          return navigate('/manager/account/userManager');
        case accountMenu.team:
          return navigate('/manager/account/teamManager');
        case accountMenu.payment:
          alert('Comming Soon!');
          return navigate('/manager/service/appManager');
        case accountMenu.plan:
          alert('Comming Soon!');
          return navigate('/manager/service/appManager');
        default:
          return navigate('/manager/service/appManager');
      }
    },
    [navigate]
  );

  const onClickLogoutHandler = useCallback(
    (event) => {
      event.preventDefault();
      popupCloseFn(event);
      dispatch(setLogOut());
      navigate('/login');
    },
    [popupCloseFn, navigate, dispatch, setLogOut]
  );

  // 팀 클릭 시 팀 정보 요청 처리
  //(TODO: 이부분 필요한지 모르겠음... 기존과 변경됨)
  const onClickRequestTeamInfo = useCallback(
    (obj: subAccountType) => {
      if (userInfo) {
        const { userId } = userInfo;
        const { email, teamId, teamName } = obj;
      }
    },
    [userInfo, dispatch, selectedCountry, selectedLanguage]
  );

  return (
    <>
      {userInfo && (
        <div className="account-menu-wrap">
          <div className="my-account">
            <p className="my-email" title="sam@aixinc.io index">
              <span>{userInfo?.email}</span> {userInfo?.teamName}
            </p>
            <div className="header-mypage">
              {/* 프로필 img 추가시 노출 */}
              {userInfo?.profileImageUrl && <img src={userInfo.profileImageUrl} alt="" />}
              <span>mypage</span>
            </div>
          </div>
          {userInfo?.subAccount?.length > 0 && (
            <ul className="other-account">
              {userInfo.subAccount.map((item, index) => (
                <li key={index} className={item.email === selectedSubAccount?.email ? 'active' : ''}>
                  <div className="other-mail">
                    <p className="nic-name" style={{ color: 'red' }} title={item.teamName}>
                      {item.teamName}
                    </p>
                    <p className="mail-addr" title={item.email}>
                      {/* 아래 부분에 myApp competitorsApp 요청 붙이기 */}
                      <a href="#">
                        <button onClick={() => onClickRequestTeamInfo(item)}>{item.email}</button>
                      </a>
                    </p>
                  </div>
                  <button type="button" className="btn-ico-single setting" onClick={() => onClickSubAccountPopup(item)}>
                    <span className="blind">설정</span>
                  </button>
                  <div className="setting-email">
                    <input
                      type="text"
                      className="ipt-email"
                      placeholder="Change the team name"
                      value={teamNameText}
                      onChange={onChangeTeamNameText}
                    />
                    <div className="change-email" title={item.email}>
                      {`${item.email}`}
                    </div>
                    <div className="btn-wrap">
                      <button type="button" className="btn-s line" onClick={onClickRequestTeamChange}>
                        <span>Confirm</span>
                      </button>
                      <button type="button" className="btn-s line" onClick={() => onClickSubAccountPopup(null)}>
                        <span>Cancel</span>
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}

          <ul className="account-menu">
            {accountMenuArray.map((item, index) => (
              <li key={index}>
                <a href="#" className={`btn-ico ${item.name}`} onClick={() => onClickMenu(item)}>
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
          <div className="logout-wrap">
            <a href="#" className="btn-ico logout" onClick={onClickLogoutHandler}>
              Logout
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default MyAccountPopup;
